














import { Component, Mixins } from "vue-property-decorator";
import { NotImplementedItem } from "../../../../domain/document/items";
import { PropertyEditableMixin, DrawerPropertyEditableMixin, PainterPropertyEditableMixin, CheckerPropertyEditableMixin } from "./mixins";
import { DrawableItemEditorMixin } from "../mixins";
import JsonViewer from "../../../system/viewers/JsonViewer.vue";

@Component({
  components: {
    jsonViewer: JsonViewer,
  },
})
export default class NotImplementedPropertyEditor extends Mixins(PropertyEditableMixin, DrawableItemEditorMixin, DrawerPropertyEditableMixin, PainterPropertyEditableMixin, CheckerPropertyEditableMixin) {
  editingSource: NotImplementedItem;

  get source(): any {
    return this.editingSource.source;
  }

  get textStyle(): any {
    return {
      width: "290px",
      height: "calc(100vh - 300px)",
    };
  }
}
